export default __webpack_public_path__ + "static/img_1400-86c94ce535b27829637b0e11e080b4a4.jpg";